import { Box, Card, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import GroupIcon from "@mui/icons-material/Group";
import MoneyIcon from "@mui/icons-material/Money";
import Translate from "../../utils/Translate";
import DotMenu from "../DotMenu";
import { formatMoney } from "../../utils/formatMoney";
import { hasAccess, accessKeys } from "../../utils/userAccess";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import { Place } from "@mui/icons-material";

export default function ClassRoomCard({
  actorAddressStreet1,
  actorAddressStreet2,
  actorAddressZipCode,
  actorAddressCity,
  extraActions,
}) {
  return (
    <Card sx={{ padding: "16px", marginBottom: "16px", transform: "translateZ(0)" }}>
      <Typography variant="h6" sx={{ marginTop: "6px", marginLeft: "12px" }}>
        {actorAddressStreet1}
      </Typography>
      <Box sx={{ position: "fixed", top: "18px", right: "16px" }}>
        <DotMenu content={extraActions} horizontal />
      </Box>
      <Grid container spacing={4} direction="column" sx={{ padding: "30px 0px 16px 18px" }}>
        <Grid container alignItems="center" spacing={0}>
          <Place />
          {actorAddressStreet2 || actorAddressZipCode || actorAddressZipCode ? (
            <Stack direction="column" gap={0.5}>
              <Box marginLeft="19px">{actorAddressStreet2}</Box>
              <Box marginLeft="19px">{`${actorAddressZipCode ?? ""}${actorAddressZipCode ? " " : ""}${
                actorAddressCity ?? ""
              }`}</Box>
            </Stack>
          ) : (
            "—"
          )}
        </Grid>
      </Grid>
    </Card>
  );
}
